'use es6';

import tinymce from 'tinymce';
import { HS_HR } from '../constants/plugins';
import { i18nWithNameSpace } from '../utils/i18n';
import { trackInteraction } from '../utils/usageTracking';
import { INSERT_HORIZONTAL_RULE } from '../constants/usageTracking';
import { addHandlers } from './handlers';
import { CANVAS_HR } from '../constants/toolbar';
const i18nKey = i18nWithNameSpace('TinymcePlugins.hshr');
function hrPlugin(editor) {
  const onClick = () => {
    editor.execCommand('mceInsertContent', false, '<hr />');
    trackInteraction(editor, 'tinymceCommand', INSERT_HORIZONTAL_RULE);
  };
  tinymce.canvas.addMenuItem(editor, CANVAS_HR, {
    text: i18nKey('menuItem'),
    onClick
  });
  addHandlers(editor);
}
tinymce.PluginManager.add(HS_HR, hrPlugin);